import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { parseQueryParams } from 'pricing-pages-api/utils/queryUtils';
import { useGetAddOnsQuery } from '../../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.hooks';
import { AddOnCardLayoutUI } from '../../../components/available-add-ons-list/AddOnCardLayoutUI';
import FallbackErrorBanner from '../../../components/common/loading/FallbackErrorBanner';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionContainer } from '../../containers/PurchaseMotionContainer';
import { createAddOnCardTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAddOnTitleKey = productApiName => {
  return `pricing-pages-ui.productNamesV2.${productApiName}.title`;
};
export const AddOnsList = () => {
  const history = useHistory();
  const {
    searchAddOns: addOnQueryParam
  } = parseQueryParams(history.location.search);
  const searchTerm = Array.isArray(addOnQueryParam) ? addOnQueryParam[0] : addOnQueryParam;
  const [filteredAddOns, setFilteredAddOns] = useState([]);
  const addOnsQuery = useGetAddOnsQuery();
  const validAddOns = useMemo(() => {
    var _addOnsQuery$data, _addOnsQuery$data2;
    if (!((_addOnsQuery$data = addOnsQuery.data) !== null && _addOnsQuery$data !== void 0 && _addOnsQuery$data.eligibleAddOns)) {
      return [];
    }
    const translatedAddOns = (((_addOnsQuery$data2 = addOnsQuery.data) === null || _addOnsQuery$data2 === void 0 ? void 0 : _addOnsQuery$data2.eligibleAddOns.filter(addOn => isValidI18nKey(getAddOnTitleKey(addOn)))) || []).map(productApiName => ({
      productApiName,
      titleText: I18n.text(`pricing-pages-ui.productNamesV2.${productApiName}.title`),
      descriptionText: I18n.text(`pricing-pages-ui.productNamesV2.${productApiName}.paragraph`)
    }));
    setFilteredAddOns(translatedAddOns);
    return translatedAddOns;
  }, [addOnsQuery.data]);
  const handleSearchAddOns = useCallback(inputSearchTerm => {
    if (!inputSearchTerm.trim()) {
      setFilteredAddOns(validAddOns);
      history.push({
        pathname: history.location.pathname,
        search: ''
      });
      return;
    }
    const filteredValues = validAddOns.filter(addOn => {
      return addOn.titleText.toLowerCase().includes(inputSearchTerm.toLowerCase()) || addOn.descriptionText.toLowerCase().includes(inputSearchTerm.toLowerCase());
    });
    setFilteredAddOns(filteredValues);
    history.push({
      pathname: history.location.pathname,
      search: `?searchAddOns=${inputSearchTerm}`
    });
  }, [validAddOns, history]);
  useEffect(() => {
    if (searchTerm && addOnsQuery.data) {
      handleSearchAddOns(searchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addOnsQuery.data]);
  if (addOnsQuery.error) {
    return /*#__PURE__*/_jsx(FallbackErrorBanner, {});
  }
  if (addOnsQuery.loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "700px",
    marginInline: "auto",
    children: [validAddOns.length > 5 && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(SearchInput, {
        value: searchTerm,
        onChange: event => {
          handleSearchAddOns(event.target.value);
        },
        placeholder: I18n.text('pricingPage.pages.addOns.search.placeholder'),
        marginBlockEnd: "400"
      })
    }), filteredAddOns.map(({
      productApiName,
      titleText,
      descriptionText
    }) => /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
      "data-test-id": `add-on-card-${productApiName}`,
      "data-selenium-id": `add-on-card-${productApiName}`,
      title: titleText,
      description: descriptionText,
      pricing: /*#__PURE__*/_jsx(PriceByProductApiName, {
        productApiName: productApiName
      }),
      cta: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
        productApiName: productApiName,
        location: "MERCH_CARD",
        displayCount: 1,
        skipInterstitial: true,
        trackingData: createAddOnCardTrackingData(productApiName)
      })
    }, productApiName))]
  });
};